module.exports = {
  id: 8,
  name: 'Mountain Climbers',
  categories: ['cardio', 'core', 'strength'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Core',
  points: 13,
  instructions:
    'Mountain climbers time! Get in a push-up position, then bring your right knee up to your chest, then your left knee, then your right knee again. Keep alternating like you are climbing a mountain! This makes you fast and strong!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to climb a mountain? Get in push-up position!',
    },
    {
      time: 3,
      text: 'Here we go!',
    },
    {
      time: 6,
      text: '3, 2, 1, START!',
    },
    // SET 1 - 10 reps
    {
      time: 9,
      text: 'Number 1! Drive your right knee toward your chest!',
    },
    {
      time: 11,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 13,
      text: 'Number 2! Drive your right knee toward your chest!',
    },
    {
      time: 15,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 17,
      text: 'Number 3! Drive your right knee toward your chest!',
    },
    {
      time: 19,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 21,
      text: 'Number 4! Drive your right knee toward your chest!',
    },
    {
      time: 23,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 25,
      text: 'Number 5! Drive your right knee toward your chest!',
    },
    {
      time: 27,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 29,
      text: 'Number 6! Drive your right knee toward your chest!',
    },
    {
      time: 31,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 33,
      text: 'Number 7! Drive your right knee toward your chest!',
    },
    {
      time: 35,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 37,
      text: 'Number 8! Drive your right knee toward your chest!',
    },
    {
      time: 39,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 41,
      text: 'Number 9! Drive your right knee toward your chest!',
    },
    {
      time: 43,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 45,
      text: 'Number 10! Last one of this set!',
    },
    {
      time: 47,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 49,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 51,
      text: 'Great job! Take a break.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 54,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 57,
      text: 'Shake out your legs and get ready!',
    },
    {
      time: 60,
      text: 'You are building incredible core strength!',
    },
    {
      time: 63,
      text: 'Ready for round two?',
    },
    {
      time: 66,
      text: '3, 2, 1, START!',
    },
    // SET 2 - 10 reps
    {
      time: 69,
      text: 'Number 1! Drive your right knee toward your chest!',
    },
    {
      time: 71,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 73,
      text: 'Number 2! Drive your right knee toward your chest!',
    },
    {
      time: 75,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 77,
      text: 'Number 3! Drive your right knee toward your chest!',
    },
    {
      time: 79,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 81,
      text: 'Number 4! Drive your right knee toward your chest!',
    },
    {
      time: 83,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 85,
      text: 'Number 5! Drive your right knee toward your chest!',
    },
    {
      time: 87,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 89,
      text: 'Number 6! Drive your right knee toward your chest!',
    },
    {
      time: 91,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 93,
      text: 'Number 7! Drive your right knee toward your chest!',
    },
    {
      time: 95,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 97,
      text: 'Number 8! Drive your right knee toward your chest!',
    },
    {
      time: 99,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 101,
      text: 'Number 9! Drive your right knee toward your chest!',
    },
    {
      time: 103,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 105,
      text: 'Number 10! Last one of this set!',
    },
    {
      time: 107,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 109,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 111,
      text: 'Great job! Take another break.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 114,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 117,
      text: 'Shake out your legs and get ready!',
    },
    {
      time: 120,
      text: 'You are building incredible core strength!',
    },
    {
      time: 123,
      text: 'Ready for round three?',
    },
    {
      time: 126,
      text: '3, 2, 1, START!',
    },
    // SET 3 - 10 reps
    {
      time: 129,
      text: 'Number 1! Drive your right knee toward your chest!',
    },
    {
      time: 131,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 133,
      text: 'Number 2! Drive your right knee toward your chest!',
    },
    {
      time: 135,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 137,
      text: 'Number 3! Drive your right knee toward your chest!',
    },
    {
      time: 139,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 141,
      text: 'Number 4! Drive your right knee toward your chest!',
    },
    {
      time: 143,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 145,
      text: 'Number 5! Drive your right knee toward your chest!',
    },
    {
      time: 147,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 149,
      text: 'Number 6! Drive your right knee toward your chest!',
    },
    {
      time: 151,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 153,
      text: 'Number 7! Drive your right knee toward your chest!',
    },
    {
      time: 155,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 157,
      text: 'Number 8! Drive your right knee toward your chest!',
    },
    {
      time: 159,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 161,
      text: 'Number 9! Drive your right knee toward your chest!',
    },
    {
      time: 163,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 165,
      text: 'Number 10! Last one of this set!',
    },
    {
      time: 167,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 169,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 171,
      text: 'Great job! Take another break.',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 174,
      text: 'Take a deep breath in and out.',
    },
    {
      time: 177,
      text: 'Shake out your legs and get ready!',
    },
    {
      time: 180,
      text: 'You are building incredible core strength!',
    },
    {
      time: 183,
      text: 'Ready for the final round?',
    },
    {
      time: 186,
      text: '3, 2, 1, START!',
    },
    // SET 4 - 10 reps
    {
      time: 189,
      text: 'Number 1! Drive your right knee toward your chest!',
    },
    {
      time: 191,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 193,
      text: 'Number 2! Drive your right knee toward your chest!',
    },
    {
      time: 195,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 197,
      text: 'Number 3! Drive your right knee toward your chest!',
    },
    {
      time: 199,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 201,
      text: 'Number 4! Drive your right knee toward your chest!',
    },
    {
      time: 203,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 205,
      text: 'Number 5! Drive your right knee toward your chest!',
    },
    {
      time: 207,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 209,
      text: 'Number 6! Drive your right knee toward your chest!',
    },
    {
      time: 211,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 213,
      text: 'Number 7! Drive your right knee toward your chest!',
    },
    {
      time: 215,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 217,
      text: 'Number 8! Drive your right knee toward your chest!',
    },
    {
      time: 219,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 221,
      text: 'Number 9! Drive your right knee toward your chest!',
    },
    {
      time: 223,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 225,
      text: 'Number 10! Last one ever!',
    },
    {
      time: 227,
      text: 'Drive your right knee toward your chest!',
    },
    {
      time: 229,
      text: 'Drive your left knee toward your chest!',
    },
    {
      time: 231,
      text: 'Incredible work! You are done!',
    },
    // COMPLETION
    {
      time: 234,
      text: 'Amazing work! You just did 40 mountain climbers!',
    },
    {
      time: 237,
      text: 'You are building incredible core strength and cardio!',
    },
    {
      time: 240,
      text: 'Great job, mountain climber champion!',
    },
  ],
};
